var render = function render(){var _vm=this,_c=_vm._self._c;return _c('device-card',{attrs:{"flat":"","device":_vm.device,"title":_vm.$t('device-card-mec-meter.title').toString(),"icon":"tune"}},[_c('sub-devices',[_c('mec-meter',{attrs:{"device":_vm.device}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }